import { API_URL, API_STATUS } from './../../constants/config';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService } from '../common/common.service';
@Injectable()
export class UserService {

	constructor(private http: HttpClient, private _common: CommonService) { }

	register(data) {
		let registerUrl = API_URL + 'marketing/signup';
		return new Promise((resolve, reject) => {
			this._common.toggleLoading(true);
			this.http.post(registerUrl, data, { withCredentials: true }).subscribe((res: any) => {
				this._common.toggleLoading(false);
				if (res.Status === API_STATUS.error) {
					this._common.showToastr('error', res.Message, 'An error occured!');
					reject(res.Message);
					return;
				}
				localStorage.setItem('CURRENT_USER', JSON.stringify(res.Data));
				this._common.storageChanged(res.Data);
				// this._common.onChangeProfile.next('signup');
				resolve(res.Data);
			}, (err) => {
				this._common.toggleLoading(false);
				reject(err);
			});
		})
	}

	login(data) {
		let loginUrl = API_URL + 'marketing/signin';
		return new Promise((resolve, reject) => {
			this._common.toggleLoading(true);
			this.http.post(loginUrl, data, { withCredentials: true }).subscribe((res: any) => {
				this._common.toggleLoading(false);
				if (res.Status === API_STATUS.error) {
					this._common.showToastr('error', res.Message, 'An error occured!');
					reject(res.Message);
					return;
				}
				localStorage.setItem('CURRENT_USER', JSON.stringify(res.Data));
				this._common.storageChanged(res.Data);
				// this._common.onChangeProfile.next('login');
				resolve(res.Data);
			}, (err) => {
				this._common.toggleLoading(false);
				reject(err);
			});
		})
	}

	logout() {
		let logoutUrl = `${API_URL}marketing/logout`;
		return new Promise((resolve, reject) => {
			this._common.toggleLoading(true);
			this.http.get(logoutUrl, { withCredentials: true }).subscribe((res: any) => {
				this._common.toggleLoading(false);
				if (res.Status === API_STATUS.error) {
					this._common.showToastr('error', res.Message, 'An error occured!');
					reject(res.Message);
					return;
				}
				localStorage.removeItem('CURRENT_USER');
				this._common.storageChanged({});
				// this._common.onChangeProfile.next('logout');
				resolve(res.Data);
			}, (err) => {
				this._common.toggleLoading(false);
				reject(err);
			})
		})
	}

	forgotPw(email) {
		let forgotPwUrl = `${API_URL}marketing/forgotpassword?email=${email}`;
		return new Promise((resolve, reject) => {
			this._common.toggleLoading(true);
			this.http.get(forgotPwUrl, { withCredentials: true }).subscribe((res: any) => {
				this._common.toggleLoading(false);
				if (res.Status === API_STATUS.error) {
					this._common.showToastr('error', res.Message, 'An error occured!');
					reject(res.Message);
					return;
				}
				resolve(res.Data);
			}, (err) => {
				this._common.toggleLoading(false);
				reject(err);
			})
		})
	}

	createNewPw(password, token) {
		let createPwUrl = `${API_URL}marketing/resetPassword?password=${password}&&token=${token}`;
		return new Promise((resolve, reject) => {
			this._common.toggleLoading(true);
			this.http.get(createPwUrl, { withCredentials: true }).subscribe((res: any) => {
				this._common.toggleLoading(false);
				if (res.Status === API_STATUS.error) {
					this._common.showToastr('error', res.Message, 'An error occured!');
					reject(res.Message);
					return;
				}
				resolve(res.Data);
			}, (err) => {
				this._common.toggleLoading(false);
				reject(err);
			})
		})
	}

	checkSession() {
		let checkSessionUrl = `${API_URL}marketing/session`;
		return this.http.get(checkSessionUrl, { withCredentials: true })
	}

}



// WEBPACK FOOTER //
// ./src/app/services/user/user.service.ts